import './App.css';
import { Component } from 'react';
import { Manager, System } from '@metaverse-systems/libecs-js';
import { DrawingComponent, PositionComponent, VisibleComponent } from './Components';
import PauseCircleOutlineIcon from '@material-ui/icons/PauseCircleOutline';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import VolumeOffIcon from '@material-ui/icons/VolumeOff';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import ReactAudioPlayer from 'react-audio-player';

const ECS = new Manager();

const vaporBlue = '#01cdfe';
const vaporPink = '#ff71ce';
const vaporPurple = '#b967ff';
const vaporYellow = '#fffb96';
const vaporGreen = '#05ffa1';

const colors = [ vaporBlue, vaporPink, vaporPurple, vaporYellow, vaporGreen, vaporBlue, vaporPink, vaporBlue, vaporPink ];

class CellDrawingSystem extends System
{
  constructor(config)
  {
    if(config === undefined) {
      config = {};
    }

    super(config);
    this.Handle = "CellDrawingSystem";
    this.ComponentRequest("PositionComponent");
    this.ComponentRequest("DrawingComponent");
    this.ComponentRequest("VisibleComponent");
  }

  ConfigUpdate = (config) => {
    Object.keys(config).forEach((key) => {
      this.config[key] = config[key];
    });

    this.config.cellHeight = Math.floor(this.config.height / this.config.rows);
    this.config.cellWidth = Math.floor(this.config.width / this.config.columns);

    this.config.drawingBoard.height = this.config.height;
    this.config.drawingBoard.width = this.config.width;
  }

  Update = () => {
    if(this.config.drawingBoard === undefined) return;

    let ctx = this.config.drawingBoard.getContext("2d");

    Object.keys(this.Container.Components["DrawingComponent"]).forEach((entity) => {
      let draw = this.Container.Components["DrawingComponent"][entity];
      let visible = this.Container.Components["VisibleComponent"][entity] !== undefined ? true : false;
      let pos = this.Container.Components["PositionComponent"][entity];

      let color = visible ? draw.color : 'black';

      let x = pos.x * this.config.cellWidth;
      let y = pos.y * this.config.cellHeight;

      ctx.fillStyle = color;
      ctx.fillRect(x, y, this.config.cellWidth, this.config.cellHeight);
    });
  }
}

class LifeSystem extends System
{
  constructor(config)
  {
    if(config === undefined) {
      config = {};
    }

    super(config);
    this.Handle = "LifeSystem";
    this.ComponentRequest("VisibleComponent");
    this.ComponentRequest("PositionComponent");
    this.ms = 0;
    this.paused = true;
    this.config.columns = config.columns;
    this.config.rows = config.rows;
    this.cells = [];
    this.to_die = [];
    this.to_live = [];
    this.generation = 1;
    this.interval = 500;
    this.updateGeneration = config.updateGeneration;
    for(let col = 0; col < config.columns; col++)
    {
      this.cells[col] = [];
    }
  }

  Pause = () => {
    this.paused = true;
  }

  Unpause = () => {
    this.paused = false;
    this.ms = 0;
  }

  Toggle = (x, y) => {
    let entity = this.CellGet(x, y);

    if(this.Container.Components["VisibleComponent"][entity] === undefined) {
      let e = this.Container.Entity(entity);
      e.Component(new VisibleComponent({}));
    } else {
      delete this.Container.Components["VisibleComponent"][entity];
    }
  }

  Clear = () => {
    Object.keys(this.Container.Components["VisibleComponent"]).forEach((entity) => {
      delete this.Container.Components["VisibleComponent"][entity];
    });
  }

  Repopulate = (p) => {
    Object.keys(this.Container.Components["PositionComponent"]).forEach((entity) => {
      if(Math.random() >= p) {
        let e = this.Container.Entity(entity);
        e.Component(new VisibleComponent({}));
      }
    });
  }

  CellGet = (x, y) => {
    let entity = "";
    Object.keys(this.Container.Components["PositionComponent"]).forEach((e) => {
      let position = this.Container.Components["PositionComponent"][e];

      if((position.x === x) && (position.y === y)) {
        entity = e;
      }
    });

    return entity;
  }

  Update = () => {
    let update = false;
    this.ms += this.DeltaTimeGet();

    while(this.to_die.length > 0) {
      let entity = this.to_die.pop();

      delete this.Container.Components["VisibleComponent"][entity];
    }

    while(this.to_live.length > 0) {
      let entity = this.to_live.pop();

      let e = this.Container.Entity(entity);
      e.Component(new VisibleComponent({}));
    }

    if(this.ms < this.interval) return;
    this.ms -= this.interval;
    if(this.paused === false) {
      update = true;
      this.generation++;
      this.updateGeneration(this.generation);
    } else {
      return;
    }

    for(let column = 0; column < this.config.columns; column++)
    {
      for(let row = 0; row < this.config.rows; row++)
      {
        if(this.cells[column][row] === undefined)
        {
          this.cells[column][row] = this.CellGet(column, row);
        }

        let pos = this.Container.Components["PositionComponent"][this.cells[column][row]];

        let neighbors = 0;
        if(update)
        {
          for(let x = -1; x < 2; x++)
          {
            for(let y = -1; y < 2; y++)
            {
              if((x === 0) && (y === 0)) continue;

              let adjusted_x = pos.x + x;
              let adjusted_y = pos.y + y;

              if(adjusted_x === this.config.columns) adjusted_x = 0;
              if(adjusted_x < 0) adjusted_x = this.config.columns - 1;

              if(adjusted_y === this.config.rows) adjusted_y = 0;
              if(adjusted_y < 0) adjusted_y = this.config.rows - 1;

              if(this.cells[adjusted_x] === undefined) continue;

              let check_cell = this.cells[adjusted_x][adjusted_y];
              if(check_cell === undefined) continue;
              if(this.Container.Components["VisibleComponent"][check_cell] !== undefined) neighbors++;
            }
          }
        }

        let die = false;
        let live = false;

        if(this.Container.Components["VisibleComponent"][this.cells[column][row]] !== undefined)
        {
          // Cell is alive

          if(update)
          {
            if(neighbors < 2) die = true;
            if(neighbors > 3) die = true;
          }
        }
        else
        {
          // Cell is dead

          if(update)
          {
            if(neighbors === 3) live = true;
          }
        }

        if(die) this.to_die.push(this.cells[column][row]);
        if(live) this.to_live.push(this.cells[column][row]);
      }
    }
  }
}

class App extends Component {
  constructor(props) {
    super(props);

    const total_rows = 18;
    const total_cols = 30;
    this.world = ECS.Container();

    let cells = [];
    for(let i = 0; i < total_rows; i++) {
      let row = [];
      for(let j = 0; j < total_cols; j++) {
        let index = Math.floor(Math.random() * colors.length);
        row.push({ 
          color: colors[index],
          visible: (Math.random() >= 0.5) ? true : false
        });
      }
      cells.push(row);
    }

    this.state = {
      audioPlaying: false,
      height: 450,
      width: 800,
      columns: total_cols,
      rows: total_rows,
      drawingSystem: new CellDrawingSystem({
        width: 0,
        height: 0,
        columns: total_cols,
        rows: total_rows
      }),
      lifeSystem: new LifeSystem({
        columns: total_cols,
        rows: total_rows,
        updateGeneration: this.updateGeneration
      }),
      paused: true,
      muted: false,
      cellWidth: 10,
      cellHeight: 10,
      cells: cells,
      generation: 1
    };

    this.world.System(this.state.drawingSystem);
    this.world.System(this.state.lifeSystem);

    let rowCount = 0;
    let columnCount = 0;
    cells.forEach((row) => {
      row.forEach((cell) => {
        let e = this.world.Entity();
        e.Component(new PositionComponent({ x: columnCount, y: rowCount }));
        e.Component(new DrawingComponent({ color: cell.color }));
        if(cell.visible === true) {
          e.Component(new VisibleComponent({}));
        }
        columnCount++;
      });
      rowCount++;
      columnCount = 0;
    });

    console.log(this.world.Export());
    this.world.Start(50);
  }

  componentDidMount = () => {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    screen.orientation.lock("landscape-primary");
  }

  componentWillUnmount() {
    window.addEventListener("resize", null);
  }

  handleResize = () => {
    const div = document.getElementById('drawing_board');
    const width = window.innerWidth * .85;
    const height = window.innerHeight;
    
    const cellHeight = Math.floor(height / this.state.rows);
    this.setState({ height: height, width: width, 
                    cellHeight: cellHeight, 
                    cellWidth: Math.floor(width / this.state.columns) });
    if(this.state.drawingSystem !== null) {
      this.state.drawingSystem.ConfigUpdate({ height: height, width: width, drawingBoard: div });
    }
  }

  updateGeneration = (g) => {
    this.setState({ generation: g });
  }

  Pause = () => {
    if(this.state.lifeSystem.paused) {
      this.state.lifeSystem.Unpause();
      this.setState({ paused : false });
      if(!this.state.audioPlaying) {
        this.setState({ audioPlaying : true });
        this.handleResize();
        document.getElementById('rap').play();
      }
    } else {
      this.state.lifeSystem.Pause();
      this.setState({ paused : true });
    }
  }

  Mute = () => {
    if(this.state.muted) {
      this.setState({ muted: false });
      document.getElementById('rap').muted = false;
    } else {
      this.setState({ muted: true });
      document.getElementById('rap').muted = true;
    }
  }

  Clear = () => {
    this.state.lifeSystem.Clear();
  }

  Repopulate = () => {
    this.state.lifeSystem.Repopulate(0.85);
  }

  Click = (e) => {
    let rect = document.getElementById('drawing_board').getBoundingClientRect();
    let x = Math.floor((e.clientX - rect.left) / this.state.cellWidth);
    let y = Math.floor((e.clientY - rect.top) / this.state.cellHeight);

    this.state.lifeSystem.Toggle(x, y);
  }

  onChange = (e) => {
  }

  render = () => {
    return (
      <>
        <div style={ {float: 'left', width: this.state.width} }>
          <canvas id='drawing_board' height={this.state.height} onClick={this.Click} style={ {float: 'left', width: this.state.width} }>
          </canvas>
        </div>
        <div style={ {float: 'left', width: (window.innerWidth * .15)} }>
         <div style={ {textAlign: 'center', marginBottom: '20%', marginTop: '10%'} }>
            <div>
            { this.state.paused ?
              <PlayCircleOutlineIcon onClick={()=>this.Pause()} fontSize="large" /> :
              <PauseCircleOutlineIcon onClick={()=>this.Pause()} fontSize="large" />
            }
            </div>
            <div style={ {textAlign: 'center'} }>Generation: { this.state.generation }</div>
          </div>

          <div style={ {textAlign: 'center', marginBottom: '20%'} }>
            <div style={ {marginBottom: '10%'} }>
              <DeleteSweepIcon onClick={()=>this.Clear()} fontSize="large" />
            </div>
            <div>
              <AddCircleOutlineIcon onClick={()=>this.Repopulate()} fontSize="large" />
            </div>
          </div>

          <div style={ {textAlign: 'center', marginBottom: '20%'} }>
            { this.state.muted ?
              <VolumeUpIcon onClick={()=>this.Mute()} fontSize="large" /> :
              <VolumeOffIcon onClick={()=>this.Mute()} fontSize="large" />
            }
            <ReactAudioPlayer id="rap"
              src="2AM_in_Shimokitazawa_1.0_128k.mp3"
              loop
            />
          </div>
        </div>
      </>
    );
  }
}

export default App;
